import { Button } from 'kl-b2c-ui-kit';
import styled, { CSSObject } from 'styled-components';
import {
    colorWhite,
    headerHeight,
    mediaMd,
    mediaSm,
    mediaXs,
} from 'theme/theme-helper-selectors';

export const Container = styled.div`
    position: relative;
    margin-top: -${headerHeight};
    padding-top: ${headerHeight};
    background-color: #000000;
    margin-bottom: 100px;

    @media (${mediaMd}) {
        margin-bottom: 150px;
    }

    @media (${mediaSm}) {
        margin-bottom: 140px;
    }

    &:after {
        content: '';
        width: 100%;
        height: 135px;
        position: absolute;
        background: #000000;
        bottom: 0;
        transform-origin: left bottom;
        transform: translateY(25%) skewY(3deg);
        border-radius: 0 0 40px 40px;
        z-index: 2;

        @media (${mediaMd}) {
            bottom: -30px;
        }

        @media (${mediaSm}) {
            bottom: -20px;
            height: 100px;
        }
    }
`;

export const Hexa = styled.div`
    position: absolute;
    z-index: 2;
    width: 1557px;
    height: 1458px;
    right: -11%;
    top: -26%;
    background-image: url(/assets/images/alliance/alliance-bg.png);
    background-size: cover;
    background-repeat: no-repeat;

    @media (${mediaMd}) {
        right: -48%;
        top: -28%;
    }

    @media (${mediaSm}) {
        right: auto;
        top: -40%;
        left: -50%;
    }
`;

export const MainContainer = styled.div`
    background-color: #000000;
    position: relative;
    margin-top: -100px;
    padding-bottom: 120px;

    &:before {
        content: '';
        width: 100%;
        height: 135px;
        position: absolute;
        background: #000000;
        top: -165px;
        transform-origin: left bottom;
        transform: translateY(25%) skewY(3deg);
        border-radius: 40px 40px 0 0;
        z-index: 5;

        @media (${mediaSm}) {
            height: 100px;
            top: -125px;
        }
    }
`;

export const Title = styled.h4<{ styles?: CSSObject }>`
    color: ${colorWhite};
    font-size: 54px;
    line-height: 54px;
    font-weight: 400;

    @media (${mediaMd}) {
        font-size: 54px;
        line-height: 63px;
    }

    @media (${mediaXs}) {
        font-size: 24px;
        line-height: 27px;
    }

    ${({ styles }) => ({ ...styles })};
`;

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    margin: 0 0 46px 0;

    @media (${mediaXs}) {
        margin: 0 0 12px 0;
    }
`;

export const SubmitButton = styled(Button)<{ styles?: CSSObject }>`
    padding: 17px 24px;
    font-size: 21px;
    line-height: 24px;
    min-width: 213px;

    @media (${mediaMd}) {
        font-size: 16px;
        line-height: 20px;
        padding: 14px 24px;
        min-width: 176px;
    }

    @media (${mediaXs}) {
        font-size: 16px;
        line-height: 20px;
        padding: 14px 35px;

        width: calc(100% - 40px);
        position: absolute;
        bottom: 48px;
        left: 20px;
    }

    ${({ styles }) => ({ ...styles })};
`;
